import { ActionReducer, ActionReducerMap, MetaReducer } from "@ngrx/store";
import { usuarioReducer, UsuarioState } from "./redux/usuario/usuario.reducer";
import { globalReducer, GlobalState } from "./redux/global/global.reducer";
import { localStorageSync } from 'ngrx-store-localstorage';

export interface AppState{
    usuarioApp: UsuarioState;
    globalApp: GlobalState;
}

export const appReducers: ActionReducerMap<AppState> = {    
    usuarioApp: usuarioReducer,  
    globalApp: globalReducer  
}

const reducerKeys = ['usuarioApp', 'globalApp'];
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({keys: reducerKeys, rehydrate:true})(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];